module.exports = __webpack_public_path__ + "assets/img/part1.d016ec97.png";